<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="technologyTrainFlowForm" :model="formData" class="full-width-input" :disable="readOnly"
      :rules="rules" style="width: 100%;"
      label-width="150px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="主题（20字以上）" prop="TechnologyTrain.trainSubject">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.TechnologyTrain.trainSubject"
              :clearable="true" placeholder="主题（20字以上）"
            />
            <span class="input-item input-label" v-else>{{formData.TechnologyTrain.trainSubject}}</span>
          </el-form-item>
        </el-col>
<!--        <el-col :span="12">-->
<!--          <el-form-item label="签字表" prop="TechnologyTrain.signatureForm">-->
<!--            <el-upload v-if="!readOnly"-->
<!--              class="upload-image-item" name="uploadFile" :headers="getUploadHeaders"-->
<!--              :action="getUploadActionUrl('/admin/app/technologyTrain/upload')"-->
<!--              :data="{fieldName: 'signatureForm', asImage: true}"-->
<!--              :on-success="onSignatureFormUploadSuccess"-->
<!--              :on-remove="onSignatureFormRemoveFile"-->
<!--              :before-upload="pictureFile"-->
<!--              :on-error="onUploadError"-->

<!--              :show-file-list="false">-->
<!--              <div v-if="technologyTrainFlowForm.signatureForm.impl.fileList && technologyTrainFlowForm.signatureForm.impl.fileList[0] != null" style="position: relative">-->
<!--                <img class="upload-image-show"-->
<!--                  :src="technologyTrainFlowForm.signatureForm.impl.fileList[0].url" />-->
<!--                <div class="upload-img-del el-icon-close"-->
<!--                  @click.stop="onSignatureFormRemoveFile(null, null)" />-->
<!--              </div>-->
<!--              <i v-else class="el-icon-plus upload-image-item"></i>-->
<!--            </el-upload>-->
<!--            <template v-else>-->
<!--              <img v-for="item in technologyTrainFlowForm.signatureForm.impl.fileList" :key="item.url"-->
<!--                class="table-cell-image" :src="item.url" />-->
<!--            </template>-->
<!--          </el-form-item>-->
<!--        </el-col>-->
        <el-col :span="12">
          <el-form-item label="签字表" prop="TechnologyTrain.signatureForm">
            <el-upload v-if="!readOnly"
                       class="upload-demo" name="uploadFile" :headers="getUploadHeaders"
                       :action="getUploadActionUrl('/admin/app/technologyTrain/upload')"
                       :data="{fieldName: 'signatureForm', asImage: true}"
                       :on-success="onSignatureFormUploadSuccess"
                       :on-remove="onSignatureFormRemoveFile"
                       :before-upload="pictureFile"
                       :on-error="onUploadError"
                       :show-file-list="true"
                       :on-preview="handlePreview"
                       :limit="technologyTrainFlowForm.signatureForm.impl.maxCount"
                       :on-exceed="onUploadLimit"
                       :file-list="technologyTrainFlowForm.signatureForm.impl.fileList"
                       list-type="picture">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
            <template v-else>
              <el-image v-for="item in parseUploadData(formData.TechnologyTrain.signatureForm, {id: formData.TechnologyTrain.id,
                  fieldName: 'signatureForm', asImage: true})"
                        :preview-src-list="getPictureList(formData.TechnologyTrain.signatureForm, {id: formData.TechnologyTrain.id, fieldName: 'signatureForm', asImage: true})"
                        class="table-cell-image" :key="item.url" :src="item.url" :fit="fit">
                <div slot="error" class="table-cell-image">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </template>
          </el-form-item>
        </el-col>
<!--        <el-col :span="12">-->
<!--          <el-form-item label="现场图片" prop="TechnologyTrain.siteImages">-->
<!--            <el-upload v-if="!readOnly"-->
<!--              class="upload-image-item" name="uploadFile" :headers="getUploadHeaders"-->
<!--              :action="getUploadActionUrl('/admin/app/technologyTrain/upload')"-->
<!--              :data="{fieldName: 'siteImages', asImage: true}"-->
<!--              :on-success="onSiteImagesUploadSuccess"-->
<!--              :on-remove="onSiteImagesRemoveFile"-->
<!--              :before-upload="pictureFile"-->
<!--              :on-error="onUploadError"-->

<!--              :show-file-list="false">-->
<!--              <div v-if="technologyTrainFlowForm.siteImages.impl.fileList && technologyTrainFlowForm.siteImages.impl.fileList[0] != null" style="position: relative">-->
<!--                <img class="upload-image-show"-->
<!--                  :src="technologyTrainFlowForm.siteImages.impl.fileList[0].url" />-->
<!--                <div class="upload-img-del el-icon-close"-->
<!--                  @click.stop="onSiteImagesRemoveFile(null, null)" />-->
<!--              </div>-->
<!--              <i v-else class="el-icon-plus upload-image-item"></i>-->
<!--            </el-upload>-->
<!--            <template v-else>-->
<!--              <img v-for="item in technologyTrainFlowForm.siteImages.impl.fileList" :key="item.url"-->
<!--                class="table-cell-image" :src="item.url" />-->
<!--            </template>-->
<!--          </el-form-item>-->
<!--        </el-col>-->
          <el-col :span="12">
            <el-form-item label="现场图片" prop="TechnologyTrain.siteImages">
              <el-upload v-if="!readOnly"
                         class="upload-demo" name="uploadFile" :headers="getUploadHeaders"
                         :action="getUploadActionUrl('/admin/app/technologyTrain/upload')"
                         :data="{fieldName: 'siteImages', asImage: true}"
                         :on-success="onSiteImagesUploadSuccess"
                         :on-remove="onSiteImagesRemoveFile"
                         :before-upload="pictureFile"
                         :on-error="onUploadError"
                         :show-file-list="true"
                         :on-preview="handlePreview"
                         :limit="technologyTrainFlowForm.siteImages.impl.maxCount"
                         :on-exceed="onUploadLimit"
                         :file-list="technologyTrainFlowForm.siteImages.impl.fileList"
                         list-type="picture">
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
              <template v-else>
                <el-image v-for="item in parseUploadData(formData.TechnologyTrain.siteImages, {id: formData.TechnologyTrain.id,
                  fieldName: 'siteImages', asImage: true})"
                          :preview-src-list="getPictureList(formData.TechnologyTrain.siteImages, {id: formData.TechnologyTrain.id, fieldName: 'siteImages', asImage: true})"
                          class="table-cell-image" :key="item.url" :src="item.url" :fit="fit">
                  <div slot="error" class="table-cell-image">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </template>
            </el-form-item>
          </el-col>

<!--        <el-col :span="12">-->
<!--          <el-form-item label="附件" prop="TechnologyTrain.attachedFiles">-->
<!--            <el-upload v-if="!readOnly" name="uploadFile" :headers="getUploadHeaders" multiple-->
<!--              :action="getUploadActionUrl('/admin/app/technologyTrain/upload')"-->
<!--              :data="{fieldName: 'attachedFiles', asImage: false}"-->
<!--              :on-success="onAttachedFilesUploadSuccess"-->
<!--              :on-remove="onAttachedFilesRemoveFile"-->
<!--              :on-error="onUploadError" :on-exceed="onUploadLimit"-->
<!--              :limit="technologyTrainFlowForm.attachedFiles.impl.maxCount"-->
<!--              :file-list="technologyTrainFlowForm.attachedFiles.impl.fileList"-->
<!--              :show-file-list="true">-->
<!--              <el-button :size="defaultFormItemSize" type="primary">点击上传</el-button>-->
<!--            </el-upload>-->
<!--            <template v-else>-->
<!--              <a v-for="item in technologyTrainFlowForm.attachedFiles.impl.fileList" :key="item.url"-->
<!--                href="javascript:void(0);" @click="downloadFile(item.url, item.name)">-->
<!--                {{item.name}}-->
<!--              </a>-->
<!--            </template>-->
<!--          </el-form-item>-->
<!--        </el-col>-->

          <el-col :span="12">
            <el-form-item label="服务其他附件" prop="TechnologyTrain.attachedFiles">
              <el-upload name="uploadFile" :headers="getUploadHeaders" multiple v-if="!readOnly"
                         :action="getUploadActionUrl('/admin/app/technologyTrain/upload')"
                         :data="{fieldName: 'attachedFiles', asImage: false}"
                         :on-success="onAttachedFilesUploadSuccess"
                         :on-remove="onAttachedFilesRemoveFile"
                         :on-error="onUploadError" :on-exceed="onUploadLimit"
                         :limit="technologyTrainFlowForm.attachedFiles.impl.maxCount"
                         :file-list="technologyTrainFlowForm.attachedFiles.impl.fileList"
                         :show-file-list="false">
                <el-button :size="defaultFormItemSize" type="primary">点击上传</el-button>
              </el-upload>
              <div v-if="technologyTrainFlowForm.attachedFiles.impl.fileList && technologyTrainFlowForm.attachedFiles.impl.fileList[0] != null" style="position: relative">
                <div v-for="(item,index) in technologyTrainFlowForm.attachedFiles.impl.fileList" :key="item.url"
                     style="display:flex;margin-top: 5px;">
                  <div> {{item.name}}</div>
                  <div style="margin-left: 15px;display: inline-flex">

                    <el-button type="primary" @click="downloadFile(item.url, item.name)">下载</el-button>
                    <el-button type="primary" @click="previewFile(item.url, item.filename)">预览</el-button>
                    <el-button type="primary" v-if="!readOnly"
                               @click="deleteAttachedFiles(item,technologyTrainFlowForm.attachedFiles.impl.fileList,index)">删除</el-button>
                  </div>

                </div>
              </div>
              <template v-else>
                <a v-for="item in technologyTrainFlowForm.attachedFiles.impl.fileList" :key="item.url"
                   href="javascript:void(0);" @click="downloadFile(item.url, item.name)">
                  {{item.name}}
                </a>
              </template>
            </el-form-item>
          </el-col>
      </el-row>
    </el-form>
    <el-image-viewer v-if="imgViewerVisible" :on-close="closeImgViewer" :url-list="imgList" />

  </div>
</template>

<script>
import { mapActions } from 'vuex';
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
import flowMixins from '../../mixins/flowMixins.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { TechnologyTrainController, DictionaryController } from '@/api';
import { FlowOperationController } from '@/api/flowController.js';

const processDefinitionKey = 'technologyTrainFlow';

export default {
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')

  },
  name: 'technologyTrainFlowForm',
  props: {
    // 是否运行时任务
    isRuntimeTask: {
      type: [Boolean, String]
    },
    // 是否草稿
    isDraft: {
      type: [Boolean, String],
      default: false
    },
    // 是否只读
    readOnly: {
      type: Boolean,
      default: false
    },
    // 流程实例id
    processInstanceId: {
      type: String
    },
    // 抄送消息id
    messageId: {
      type: String
    },
    // 当前任务实例id
    taskId: {
      type: String
    },
    // 任务变量列表
    taskVariableList: {
      type: Array
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, flowMixins],
  data () {
    return {
      imgViewerVisible: false,
      imgList: [],
      fit: 'scale-down',
      formData: {
        TechnologyTrain: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          trainSubject: undefined,
          signatureForm: undefined,
          siteImages: undefined,
          attachedFiles: undefined,
          specialistId: undefined,
          specialistName: undefined,
          auditStatus: undefined,
          isDatasourceInit: false
        }
      },
      // 保存草稿后返回的taskId
      draftTaskId: undefined,
      // 保存草稿后返回的流程实例ID
      draftProcessInstanceId: undefined,
      rules: {
        'TechnologyTrain.trainSubject': [
          {required: true, message: '请输入主题', trigger: 'blur'},
          { min: 20, message: '20字以上', trigger: 'blur' }

        ],
        // 'TechnologyTrain.signatureForm': [
        //   {required: true, message: '请输入签字表', trigger: 'blur'}
        // ],
        'TechnologyTrain.siteImages': [
          {required: true, message: '请输入现场图片', trigger: 'blur'}
        ]
      },
      technologyTrainFlowForm: {
        formFilter: {
        },
        formFilterCopy: {
        },
        signatureForm: {
          impl: new UploadWidget(1)
        },
        siteImages: {
          impl: new UploadWidget(1)
        },
        attachedFiles: {
          impl: new UploadWidget(1)
        },
        isInit: false
      }
    }
  },
  methods: {
    // 启动流程
    handlerStart (operation, copyItemList, xml) {
      // 启动并保存草稿后再次提交
      if (this.draftProcessInstanceId != null && this.draftTaskId != null) {
        return this.handlerOperation(operation, copyItemList);
      }
      return new Promise((resolve, reject) => {
        this.$refs.technologyTrainFlowForm.validate(valid => {
          if (!valid) return reject();
          this.preHandlerOperation(operation, true, xml).then(res => {
            let formData = this.getMasterData(operation.type, (res || {}).assignee);
            return TechnologyTrainController.startAndTakeUserTaskTechnologyTrainFlow(this, {
              processDefinitionKey: processDefinitionKey,
              taskVariableData: {
                ...formData.taskVariableData,
                latestApprovalStatus: operation.latestApprovalStatus
              },
              flowTaskCommentDto: {
                approvalType: operation.type
              },
              technologyTrainDto: {
                ...formData.masterData
              },
              ...formData.relationData,
              copyData: (copyItemList || []).reduce((retObj, item) => {
                retObj[item.type] = item.id;
                return retObj;
              }, {})
            });
          }).then(res => {
            this.$message.success('启动成功！');
            resolve();
          }).catch(e => {
            reject(e);
          });
        });
      });
    },
    // 流程操作
    handlerOperation (operation, copyItemList, xml) {
      return new Promise((resolve, reject) => {
        this.$refs.technologyTrainFlowForm.validate(valid => {
          if (!valid) return reject();
          this.preHandlerOperation(operation, this.isDraft, xml).then(res => {
            // 加签、减签操作
            if (operation.type === this.SysFlowTaskOperationType.CO_SIGN || operation.type === this.SysFlowTaskOperationType.SIGN_REDUCTION) {
              return this.submitConsign((res || {}).assignee, operation.type === this.SysFlowTaskOperationType.CO_SIGN);
            }
            // 自由跳
            if (operation.type === this.SysFlowTaskOperationType.FREE_JUMP) {
              return FlowOperationController.freeJump(this, {
                processInstanceId: this.processInstanceId,
                sourceTaskId: this.taskId,
                targetTaskKey: (res || {}).targetTaskKey,
                delegateAssignee: (res || {}).assignee,
                taskComment: (res || {}).message,
                taskVariableData: {
                  latestApprovalStatus: operation.latestApprovalStatus
                }
              });
            }
            // 驳回操作
            if (operation.type === this.SysFlowTaskOperationType.REJECT || operation.type === this.SysFlowTaskOperationType.REJECT_TO_TASK) {
              return FlowOperationController.rejectRuntimeTask(this, {
                processInstanceId: this.processInstanceId,
                taskId: this.taskId,
                targetTaskKey: (res || {}).targetTaskKey,
                taskComment: (res || {}).message,
                taskVariableData: {
                  latestApprovalStatus: operation.latestApprovalStatus
                }
              });
            }
            // 驳回到起点
            if (operation.type === this.SysFlowTaskOperationType.REJECT_TO_START) {
              return FlowOperationController.rejectToStartUserTask(this, {
                processInstanceId: this.processInstanceId,
                taskId: this.taskId,
                taskComment: (res || {}).message,
                taskVariableData: {
                  latestApprovalStatus: operation.latestApprovalStatus
                }
              });
            }
            // 撤销操作
            if (operation.type === this.SysFlowTaskOperationType.REVOKE) {
              this.$confirm('是否撤销此任务？').then(res => {
                return FlowOperationController.rejectHistoricTask(this, {
                  processInstanceId: this.processInstanceId,
                  taskId: this.taskId,
                  taskComment: '任务处理人撤销任务',
                  taskVariableData: {
                    latestApprovalStatus: operation.latestApprovalStatus
                  }
                });
              }).catch(e => {
                return Promise.reject(e);
              });
            }
            let formData = this.getMasterData(operation.type, (res || {}).assignee);
            let params = {
              taskId: this.taskId || this.draftTaskId,
              processInstanceId: this.processInstanceId || this.draftProcessInstanceId,
              flowTaskCommentDto: {
                taskComment: (res || {}).message,
                approvalType: operation.type,
                delegateAssignee: operation.type === this.SysFlowTaskOperationType.TRANSFER ? (res || {}).assignee : undefined
              },
              taskVariableData: {
                ...formData.taskVariableData,
                latestApprovalStatus: operation.latestApprovalStatus
              },
              copyData: (copyItemList || []).reduce((retObj, item) => {
                retObj[item.type] = item.id;
                return retObj;
              }, {})
            }
            // 非只读状态下，提交修改数据
            if (!this.readOnly) {
              // 主表数据
              params.technologyTrainDto = {
                ...formData.masterData
              };
              // 关联数据
              params = {
                ...params,
                ...formData.relationData
              };
            }

            return TechnologyTrainController.submitUserTaskTechnologyTrainFlow(this, params);
          }).then(res => {
            this.reloadMessage(this);
            if (operation.type !== this.SysFlowTaskOperationType.CO_SIGN && operation.type !== this.SysFlowTaskOperationType.SIGN_REDUCTION) {
              this.$message.success(operation.label + '成功！');
            }
            resolve();
          }).catch(e => {
            console.log(e);
          });
        });
      });
    },
    // 保存草稿
    handlerDraft () {
      return new Promise((resolve, reject) => {
        let formData = this.getFormDataImpl();
        let params = {
          processDefinitionKey: processDefinitionKey,
          processInstanceId: this.processInstanceId || this.draftProcessInstanceId,
          technologyTrainDto: {
            ...formData.masterData
          },
          ...formData.relationData
        }
        TechnologyTrainController.startAndSaveDraftTechnologyTrainFlow(this, params).then(res => {
          this.$message.success('草稿保存成功！');
          this.draftProcessInstanceId = res.data.processInstanceId;
          this.draftTaskId = res.data.taskId;
          resolve();
        }).catch(e => {
          reject(e);
        });
      });
    },
    // 获取表单数据
    getFormDataImpl () {
      // 一对一、一对多、多对多关联数据
      let relationData = {};

      return {
        masterData: {
          ...this.formData.TechnologyTrain
        },
        relationData: relationData
      }
    },
    // 获取流程表单数据
    getMasterData (operationType, assignee) {
      let taskVariableData;
      if (Array.isArray(this.taskVariableList) && this.taskVariableList.length > 0) {
        taskVariableData = this.taskVariableList.reduce((retObj, item) => {
          retObj[item.variableName] = this.formData.TechnologyTrain[item.variableName] || '';
          return retObj;
        }, {});
      }
      // 会签操作设置多实例处理人集合
      assignee = (assignee && assignee !== '') ? assignee.split(',') : undefined;
      if (operationType === this.SysFlowTaskOperationType.MULTI_SIGN) {
        if (taskVariableData == null) taskVariableData = {};
        taskVariableData.assigneeList = assignee;
      } else if (operationType === this.SysFlowTaskOperationType.SET_ASSIGNEE) {
        if (taskVariableData == null) taskVariableData = {};
        taskVariableData.appointedAssignee = Array.isArray(assignee) ? assignee.join(',') : undefined;
      }

      return {
        ...this.getFormDataImpl(),
        taskVariableData
      }
    },
    // 初始化流程表单
    initFormData () {
      if (!this.isStartFlow) {
        // 流程办理
        let params = {
          processInstanceId: this.processInstanceId,
          taskId: this.taskId
        }
        let httpCall = null;
        if (this.isDraft || this.isDraft === 'true') {
          // 草稿数据
          httpCall = FlowOperationController.viewDraftData(this, {
            processDefinitionKey: processDefinitionKey,
            processInstanceId: this.processInstanceId
          });
        } else if (this.messageId != null) {
          // 抄送消息
          httpCall = FlowOperationController.viewCopyBusinessData(this, {
            messageId: this.messageId
          });
        } else {
          httpCall = (this.taskId && this.isRuntime) ? TechnologyTrainController.viewTaskBusinessDataTechnologyTrainFlow(this, params) : TechnologyTrainController.viewHistoricTaskBusinessDataTechnologyTrainFlow(this, params)
        }
        httpCall.then(res => {
          this.formData.TechnologyTrain = { ...res.data };
          let signatureFormDownloadParams = {
            id: this.formData.TechnologyTrain.id,
            fieldName: 'signatureForm',
            asImage: true
          }
          this.technologyTrainFlowForm.signatureForm.impl.fileList = this.parseUploadData(this.formData.TechnologyTrain.signatureForm, signatureFormDownloadParams);
          let siteImagesDownloadParams = {
            id: this.formData.TechnologyTrain.id,
            fieldName: 'siteImages',
            asImage: true
          }
          this.technologyTrainFlowForm.siteImages.impl.fileList = this.parseUploadData(this.formData.TechnologyTrain.siteImages, siteImagesDownloadParams);
          let attachedFilesDownloadParams = {
            id: this.formData.TechnologyTrain.id,
            fieldName: 'attachedFiles',
            asImage: false
          }
          this.technologyTrainFlowForm.attachedFiles.impl.fileList = this.parseUploadData(this.formData.TechnologyTrain.attachedFiles, attachedFilesDownloadParams);
          // 获取一对多、多对多数据
          this.refreshTechnologyTrainFlowForm(true);
        }).catch(e => {});
      } else {
        // 启动流程
      }
    },
    onCancel (isSuccess) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess);
      }
    },
    /**
     * 更新科技培训表单
     */
    refreshTechnologyTrainFlowForm (reloadData = false) {
      if (!this.technologyTrainFlowForm.isInit) {
        // 初始化下拉数据
      }
      this.technologyTrainFlowForm.isInit = true;
    },
    /**
     * 签字表上传成功
     */
    onSignatureFormUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.uploadPath = response.data.uploadPath;
        file.url = URL.createObjectURL(file.raw);
        this.technologyTrainFlowForm.signatureForm.impl.onFileChange(file, fileList);
        this.formData.TechnologyTrain.signatureForm = this.fileListToJson(this.technologyTrainFlowForm.signatureForm.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除签字表
     */
    onSignatureFormRemoveFile (file, fileList) {
      this.technologyTrainFlowForm.signatureForm.impl.onFileChange(file, fileList);
      this.formData.TechnologyTrain.signatureForm = this.fileListToJson(this.technologyTrainFlowForm.signatureForm.impl.fileList);
    },
    /**
     * 现场图片上传成功
     */
    onSiteImagesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.uploadPath = response.data.uploadPath;
        file.url = URL.createObjectURL(file.raw);
        this.technologyTrainFlowForm.siteImages.impl.onFileChange(file, fileList);
        this.formData.TechnologyTrain.siteImages = this.fileListToJson(this.technologyTrainFlowForm.siteImages.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除现场图片
     */
    onSiteImagesRemoveFile (file, fileList) {
      this.technologyTrainFlowForm.siteImages.impl.onFileChange(file, fileList);
      this.formData.TechnologyTrain.siteImages = this.fileListToJson(this.technologyTrainFlowForm.siteImages.impl.fileList);
    },
    /**
     * 附件上传成功
     */
    onAttachedFilesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.uploadPath = response.data.uploadPath;
        file.url = URL.createObjectURL(file.raw);
        this.technologyTrainFlowForm.attachedFiles.impl.onFileChange(file, fileList);
        this.formData.TechnologyTrain.attachedFiles = this.fileListToJson(this.technologyTrainFlowForm.attachedFiles.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    closeImgViewer () {
      this.imgViewerVisible = false;
    },
    handlePreview (file) {
      this.imgViewerVisible = true
      this.imgList = []
      this.imgList.push(file.url)
    },
    deleteAttachedFiles (file, fileList, index) {
      fileList.splice(index, 1)
      this.onAttachedFilesRemoveFile(file, fileList)
    },
    /**
     * 移除附件
     */
    onAttachedFilesRemoveFile (file, fileList) {
      this.technologyTrainFlowForm.attachedFiles.impl.onFileChange(file, fileList);
      this.formData.TechnologyTrain.attachedFiles = this.fileListToJson(this.technologyTrainFlowForm.attachedFiles.impl.fileList);
    },
    onUploadError (e, file, fileList) {
      this.$message.error('文件上传失败');
    },
    onUploadLimit (files, fileList) {
      this.$message.error('已经超出最大上传个数限制');
    },
    formInit () {
      this.initFormData();
    },
    ...mapActions(['reloadMessage'])
  },
  computed: {
    isStartFlow () {
      return this.processInstanceId == null;
    },
    isRuntime () {
      return typeof this.isRuntimeTask === 'string' ? this.isRuntimeTask === 'true' : this.isRuntimeTask;
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  }
}
</script>
